module.exports = __webpack_public_path__ + "static/dropdown-menu-type-of-error-2-ffe3acf4bf822bc0eb2cd89ebcc0b1d5.png";